import { render } from "./Costs.vue?vue&type=template&id=2160104e&ts=true"
import script from "./Costs.vue?vue&type=script&lang=ts"
export * from "./Costs.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__